import React from 'react';
import { useLang } from '../contexts/LanguageContext';
import { cn } from '../lib/utils';

const STATUS_TONE = {
  synced: 'success', processed: 'success', transfer_done: 'success',
  paid: 'success', reconciled: 'success', completed: 'success',
  committed: 'success',
  pending: 'warning', pending_reconciliation: 'warning',
  open: 'warning', retrying: 'warning', waiting_label: 'warning',
  failed: 'danger', shortage: 'danger',
  deposit_deleted_in_qbo: 'danger',
  cancelled: 'neutral', cancelled_skipped: 'neutral',
  cancelled_after_sync: 'danger',
  refunded: 'info', manual_review: 'info', overage: 'info',
};

const TONE_VARS = {
  success: { color: 'var(--success-fg)', bg: 'var(--success-bg)', border: 'var(--success-border)' },
  warning: { color: 'var(--warning-fg)', bg: 'var(--warning-bg)', border: 'var(--warning-border)' },
  danger:  { color: 'var(--danger-fg)',  bg: 'var(--danger-bg)',  border: 'var(--danger-border)' },
  info:    { color: 'var(--info-fg)',    bg: 'var(--info-bg)',    border: 'var(--info-border)' },
  neutral: { color: 'var(--neutral-fg)', bg: 'var(--neutral-bg)', border: 'var(--neutral-border)' },
};

export default function StatusBadge({ status, className }) {
  const { t } = useLang();
  const tone = STATUS_TONE[status] || 'warning';
  const vars = TONE_VARS[tone];
  const label = t(`status.${status}`) || status;
  const pulsing = status === 'retrying';

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full text-[11px] font-semibold whitespace-nowrap',
        className
      )}
      style={{
        color: vars.color,
        background: vars.bg,
        border: `1px solid ${vars.border}`,
        padding: '4px 10px',
      }}
      data-testid={`status-badge-${status}`}
    >
      <span
        className="inline-block h-[5px] w-[5px] rounded-full"
        style={{
          background: vars.color,
          ...(pulsing ? { animation: 'pulseDot 1.6s ease infinite' } : {}),
        }}
      />
      <span>{label}</span>
    </span>
  );
}
